var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDarkKitchen && !_vm.isAlmacenero)?_c('sidebar-item',{attrs:{"link":{
    name: 'Franquicias',
    icon: 'ni ni-spaceship text-primary'
  }}},[_c('sidebar-item',{attrs:{"link":{
      name: 'Feedback',
      path: '/franquicias/feedback',
      icon: 'ni ni-single-02 text-primary'
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: 'Regalos',
      path: '/regalos/canjear',
      icon: 'ni ni-tag text-warning'
    }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }